import { observer } from 'mobx-react'
import styles from './PaySuccessPopup.module.less'
import { Dialog } from 'antd-mobile'
import { commonUtils } from '@/helpers/commonUtils'
import classNames from 'classnames'

export interface PaySuccessPopupProps {
  visible: boolean
  onClose?: () => void
  onDownload?: boolean | (() => void)
}

const PaySuccessPopupContent = observer((props: PaySuccessPopupProps) => {
  return (
    <div
      className={classNames(styles.paySuccessPopup, {
        [styles.noDownload]: typeof props.onDownload !== 'function',
      })}
    >
      <div className={styles.paySuccessPopupBg}></div>
      <div className={styles.paySuccessPopupTitle}>开通成功！</div>
      <div className={styles.paySuccessPopupContent}>
        <div className={styles.paySuccessText}>
          <p>
            添加<b>专属客服</b>，有任何问题可联系我们
          </p>
          <p className={styles.paySuccessTextTips}>（截图保存二维码，微信长按识别可添加）</p>
        </div>
        <div className={classNames(styles.qrcodeWrapper, {})}>
          <img src={commonUtils.getStaticFile('images/wxqr/customer_wxqr.png')} alt='qrcode' />
        </div>
        {typeof props.onDownload === 'function' && (
          <div
            className={styles.downloadBtn}
            onClick={() => {
              if (typeof props.onDownload === 'function') {
                props.onDownload()
              }
            }}
          >
            下载课件及教案
          </div>
        )}
      </div>
    </div>
  )
})

const PaySuccessPopup = observer((props: PaySuccessPopupProps) => {
  return (
    <Dialog
      style={
        {
          '--max-width': '100vw',
        } as React.CSSProperties
      }
      visible={props.visible}
      onClose={props.onClose}
      closeOnMaskClick
      bodyStyle={{
        padding: 0,
        backgroundColor: 'transparent',
      }}
      content={<PaySuccessPopupContent {...props} />}
      getContainer={() => document.body}
    ></Dialog>
  )
})

export default PaySuccessPopup
